import { useCallback, useEffect, useState } from "react";

import { Controller, useFormContext } from "react-hook-form";

import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Paper,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

import { OutletRoleEnum } from "@/features/outlets";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

const OutletAvailabilitySection = () => {
  const { control } = useFormContext();
  const { showSnackbar } = useSnackbar();
  const [outlets, setOutlets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadOutlets = useCallback(async () => {
    setIsLoading(true);
    try {
      const {
        data: { data },
      } = await apiClient.get("/outlets", {
        params: { role: OutletRoleEnum.RETAIL, status: true },
      });
      setOutlets(data);
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memuat cabang toko"));
    } finally {
      setIsLoading(false);
    }
  }, [showSnackbar]);

  useEffect(() => {
    loadOutlets();
  }, [loadOutlets]);

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Outlet
      </Typography>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: 1
          }}>
          <CircularProgress size={24} />
          <Typography variant="body2" sx={{ ml: 1 }}>
            Loading...
          </Typography>
        </Box>
      ) : outlets.length === 0 ? (
        <Typography variant="caption" sx={{ mt: 1 }}>
          Tidak ada outlet yang tersedia.
        </Typography>
      ) : (
        <Grid container columnSpacing={2.5} rowSpacing={1} sx={{ mt: 1 }}>
          {outlets.map((outlet) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={outlet.id}>
              <Controller
                name={`outlets.${outlet.id}`}
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={field.value || false}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    }
                    label={outlet.name}
                  />
                )}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Paper>
  );
};

export default OutletAvailabilitySection;
